import React, {useState} from 'react';
import Slider from 'react-infinite-logo-slider';
import _ from 'lodash';
import {useTranslation} from 'react-i18next';
import useMediaQuery from '../../hooks/useMediaQuery';
import {EdgeCloudUrl} from '../../constants';

const StatItem = ({value, label, color}) => (
    <div className={'HeroStats__item'}>
        <div className={'HeroStats__value'} style={{color}}>{value}</div>
        <div className={'HeroStats__label'}>{label}</div>
    </div>
);

const HeroSection = ({partnerLogos}) => {
    const {t} = useTranslation();
    const isMobile = useMediaQuery(768);
    const windowWidth = window.innerWidth;
    const [videoReady, setVideoReady] = useState(false);

    return (
        <div className={'HeroSection'}>
            {!isMobile && (
                <video
                    className={`HeroSection__video-bg ${videoReady ? 'HeroSection__video-bg--loaded' : ''}`}
                    src={'/images/hero/globe_large.mp4'}
                    autoPlay
                    loop
                    muted
                    playsInline
                    onCanPlay={() => setVideoReady(true)}
                />
            )}
            <img className={`HeroSection__globe ${!isMobile && videoReady ? 'HeroSection__globe--hidden' : ''}`}
                 src={'/images/hero/globe@2x.jpg'}
                 alt={''}
            />
            <div className={'HeroSection__content'}>
                <h1 className={'HeroSection__headline'}>
                    Where the world's compute
                    <br/>
                    comes together
                </h1>
                <p className={'HeroSection__subtitle'}>
                    On-demand GPU infrastructure built for AI, entertainment and media
                    workloads – from university research to enterprise applications.
                </p>
                <div className={'HeroSection__ctas'}>
                    <a className={'HeroSection__cta HeroSection__cta--primary'}
                       href={EdgeCloudUrl}
                       target={'_blank'}
                       rel={'noopener noreferrer'}
                    >
                        Explore Theta EdgeCloud
                    </a>
                    <a className={'HeroSection__cta HeroSection__cta--secondary'}
                       href={'#how-it-works'}
                    >
                        See how it works
                    </a>
                </div>
            </div>

            <div className={'HeroStats'}>
                <StatItem value={'30K+'} label={'Distributed Nodes'} color={'#F15D84'}/>
                <StatItem value={'50–70%'} label={'Lower Cost vs Traditional Clouds'} color={'#4CC0E9'}/>
                <StatItem value={'100s'} label={'of PetaFLOPS Available'} color={'#847DFF'}/>
            </div>

            <div className={'TrustedBy'}>
                <div className={'TrustedBy__label'}>TRUSTED BY</div>
                {
                    !_.isEmpty(partnerLogos) &&
                    <div className={'TrustedBy__slider'}>
                        <Slider
                            width={isMobile ? '120px' : '120px'}
                            duration={((partnerLogos?.length * 10) * (Math.min(windowWidth, 1366) / 1366))}
                            pauseOnHover={true}
                            blurBorders={false}
                            blurBorderColor={'#fff'}
                        >
                            {
                                _.map(partnerLogos, (partnerLogo, idx) => {
                                    return (
                                        <Slider.Slide key={idx}>
                                            <a className={'TrustedBy__logo-item'}
                                               href={_.isEmpty(partnerLogo.url) ? null : partnerLogo.url}
                                               target={'_blank'}
                                               rel={'noopener noreferrer'}
                                            >
                                                <img src={`/images/logos/customers/edgecloud/${partnerLogo.logo}`}
                                                     alt={partnerLogo.name || ''}
                                                />
                                            </a>
                                        </Slider.Slide>
                                    );
                                })
                            }
                        </Slider>
                    </div>
                }
            </div>
        </div>
    );
};

export default HeroSection;
